import * as apiClient from '../../services/api-client';
import { applyShoppingItemUpdate } from '../../services/shoppingList';



export const claimItem = async (store, itemData) => {
    const response = await apiClient.shoppinglist.claimItem(itemData.itemID, store.state.auth.cla_uid, store.state.auth.cla_token);
    //ADD THIS ITEM TO SHOPPING LIST
    let listItem = {
        ...response,
        ...itemData
    }
    let shoppinglist = [
        ...store.state.shoppinglist,
        listItem
    ];
    store.setState({ shoppinglist });
}
export const unClaimItem = async (store, itemID) => {
    await apiClient.shoppinglist.unClaimItem(itemID, store.state.auth.cla_token);
    //REMOVE THIS ITEM FROM SHOPPING LIST
    let idx = store.state.shoppinglist.map(sl => sl.itemID).indexOf(itemID);
    if(idx < 0) {
        return;
    }
    let shoppinglist = [
        ...store.state.shoppinglist.slice(0, idx),
        ...store.state.shoppinglist.slice(idx+1)
    ];
    store.setState({ shoppinglist });
}

export const updateShoppingItem = async (store, itemData) => {
    const payload = {
        ...itemData,
        userID: store.state.auth ? store.state.auth.cla_uid : itemData.userID
    };
    const responseData = await apiClient.shoppinglist.updateShoppingItem(payload, store.state.auth.cla_token);
    const response = {
        type: "shoppinglistupdate",
        data: responseData
    };
    store.setState({ response });

    let idx = store.state.shoppinglist.map(sl => sl.itemID).indexOf(itemData.itemID);
    if(idx < 0) {
        return;
    }

    // Keep the list owner. The request userID is the shopper, not the recipient.
    let listItem = applyShoppingItemUpdate(store.state.shoppinglist[idx], itemData);
    let shoppinglist = [
        ...store.state.shoppinglist.slice(0, idx),
        listItem,
        ...store.state.shoppinglist.slice(idx+1)
    ];
    store.setState({ shoppinglist });

}